import React from "react";

export interface TabPanelGroupProps {
  children?: React.ReactNode;
}

/**
 * @deprecated TabUI instead
 */
export const TabPanelGroup = ({ children }: TabPanelGroupProps) => {
  return (
    <>
      {React.Children.map(children as React.ReactElement[], (child, index) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
        return React.cloneElement(child, { index } as any);
      })}
    </>
  );
};
